@let data = vm();

@if (layout() === 'management') {
  <article
    class="okr-management-card"
    [class.okr-management-card-selected]="selected()"
    [class.okr-management-card-clickable]="clickable()"
    (click)="onCardClick()"
  >
    <div class="okr-management-card-header">
      <p class="okr-objective-label">{{ level_label() }}</p>
      <div class="okr-header-totals">
        @if (data.show_score_chip) {
          <span class="okr-header-chip" [class.okr-chip-warn]="data.score_behind_time" [matTooltip]="'Score sobre 10'">
            Score: {{ data.totalScoring | number: '1.0-1' }}
          </span>
        }
        <button
          mat-icon-button
          type="button"
          class="small-icon-button"
          [matMenuTriggerFor]="objective_menu"
          (click)="$event.stopPropagation()"
          aria-label="Acciones"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #objective_menu="matMenu">
          <button mat-menu-item type="button" (click)="view.emit()">Ver</button>
          @if (can_update()) {
            <button mat-menu-item type="button" (click)="edit.emit()">Editar</button>
          }
          @if (can_delete()) {
            <button mat-menu-item type="button" (click)="delete.emit()">Eliminar</button>
          }
        </mat-menu>
      </div>
    </div>
    <h2 class="okr-title">{{ data.objective.title }}</h2>
    @if (warnings().length > 0) {
      <ul class="okr-warnings">
        @for (warning of warnings(); track warning) {
          <li>
            <mat-icon>warning</mat-icon>
            <span>{{ warning }}</span>
          </li>
        }
      </ul>
    }
    @if (data.show_empty_score) {
      <div class="okr-empty-alert">
        <mat-icon>hourglass_empty</mat-icon>
        <span>No hay datos aún</span>
      </div>
    }
    @if (data.show_score_bar) {
      <div class="okr-score-bar" [class.okr-score-bar-warn]="data.score_behind_time">
        <span>0</span>
        <div class="okr-score-track">
          <div class="okr-score-fill" [style.width.%]="data.score_pct"></div>
        </div>
        <span>10</span>
      </div>
    }
    @if (data.show_timeline_bar) {
      <div class="okr-timeline-bar">
        <span>Start</span>
        <div class="okr-score-track">
          <div class="okr-timeline-fill" [style.width.%]="data.timeline_pct"></div>
        </div>
        <span>End</span>
      </div>
    }
  </article>
} @else {
  @if (show_company_product_context()) {
    <div class="okr-card-header">
      <div class="okr-product-meta">
        @if (data.objective.company_product_logo_url) {
          <img [src]="data.objective.company_product_logo_url" [alt]="data.objective.company_product_name" class="okr-logo" />
        }
        <div>
          <h3 class="okr-product-title">{{ data.objective.company_product_name }}</h3>
          <p class="okr-dates">{{ data.objective.period_title }} · Quedan {{ data.days_left }} días</p>
        </div>
      </div>
      <div class="okr-header-totals">
        <span class="okr-header-chip" [matTooltip]="'Score sobre 10 de tu progreso actual para llegar al objetivo'">
          Score: {{ data.totalScoring === null ? '—' : (data.totalScoring | number: '1.0-1') }}
        </span>
      </div>
    </div>
  }

  @if (show_objective_summary()) {
    <div class="okr-objective-block" [class.okr-objective-block-flush]="!show_company_product_context()">
      <div class="okr-objective-block-header">
        <p class="okr-objective-label">{{ level_label() }}</p>
        @if (show_company_product_context()) {
          <button mat-stroked-button type="button" class="okr-health-metrics-button" (click)="openExternalHealthMetrics()">
            <span
              class="okr-health-state-dot"
              [class.okr-health-state-dot-good]="data.objectiveHealthState === 'good'"
              [class.okr-health-state-dot-mid]="data.objectiveHealthState === 'mid'"
              [class.okr-health-state-dot-low]="data.objectiveHealthState === 'low'"
            ></span>
            Métricas de Salud
          </button>
        } @else {
          <div class="okr-header-totals">
            <span class="okr-header-chip" [matTooltip]="'Score sobre 10 de tu progreso actual para llegar al objetivo'">
              Score: {{ data.totalScoring === null ? '—' : (data.totalScoring | number: '1.0-1') }}
            </span>
          </div>
        }
      </div>
      <h2 class="okr-title">{{ data.objective.title }}</h2>
      @if (!show_company_product_context()) {
        <p class="okr-dates">{{ data.objective.period_title }} · Quedan {{ data.days_left }} días</p>
      }
    </div>
  }

  @if (data.key_results.length === 0) {
    <p class="okr-empty-text">Este objetivo aún no tiene Key Results.</p>
  } @else {
    <div class="okr-key-results-grid">
      @for (key_result of data.key_results; track key_result.id) {
        <app-company-objective-key-result [key_result]="key_result" [company_product_id]="objective().company_product_id" />
      }
    </div>
  }
}
